module.exports = __webpack_public_path__ + "img/59.bd2ad4c7.png";